import uniqid from 'app/libs/uniqid.js';
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    stateKey: null,
};
const { actions, reducer } = createSlice({
    name: 'stateKey',
    initialState,
    reducers: {
        setStateKey: (state, { payload: key }) => {
            const id = uniqid();
            state.stateKey = `${key}-${id}`;
        },
    },
});
export const { setStateKey } = actions;
export default reducer;
